import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_URL;

export const lcaSendOtp = async (data) => {
    // console.log("roll in call", data.roll)
    // console.log("recaptcha in call ", data.recaptcha)
    const res = await axios.post(`${BASE_URL}lauth/generateOtp`, data);
    return res;
  }
  
export const lcaVerifyOtp = async (data) => {
    // console.log("roll in call", data.roll)
    // console.log("recaptcha in call ", data.recaptcha)
    const res = await axios.post(`${BASE_URL}lauth/verifyOtp`, data);
    return res;
  }

  export const lcaConfirmProfile = async (data) => {
    // console.log("roll in call", data.roll)
    // console.log("recaptcha in call ", data.recaptcha)
    const res = await axios.post(`${BASE_URL}api/confirmProfile`, data, {
      headers: {
        'token': data.token,
        // other headers if needed
      }
    });
    return res;
  }
  